import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {TimeBetweenPipe} from '../../shared/timeBetween.pipe';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {NgSelect2Module} from 'ng-select2';
import {WidgetsModule} from '../../_metronic/partials/content/widgets/widgets.module';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDividerModule} from '@angular/material/divider';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {NgbAlertModule, NgbCollapseModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {CustomerSupportComponent} from './customer-support.component';
import {RecommendationsComponent} from './recommendations/recommendations.component';
import {ContactComponent} from './contact/contact.component';
import {ContactDialogComponent} from './contact/contact-dialog/contact-dialog.component';
import {RecommendationsDialogComponent} from './recommendations/recommendations-dialog/recommendations-dialog.component';
import {UserRolesGuardsService} from '../../../shared/guards/user-roles-guards.service';
import {SharedModuleModule} from '../../../shared-module/shared-module.module';


const routes: Routes = [
    {
        path: '',
        component: CustomerSupportComponent
    },
    {
        path: 'contact',
        component: ContactComponent,
        canActivate: [UserRolesGuardsService],
        data: {
            expectedRoles: ['ROLE_super_admin',
                'ROLE_marketing_manager', 'ROLE_marketing_operational', 'ROLE_marketing_customer_care']
        },
    },
    {
        path: 'recomandari',
        component: RecommendationsComponent
    }
]

@NgModule({
    declarations: [
        ContactComponent,
        RecommendationsComponent,
        CustomerSupportComponent,
        ContactDialogComponent,
        RecommendationsDialogComponent],
    providers: [
        TimeBetweenPipe,
        MatSnackBar
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        MatNativeDateModule,
        MatRippleModule,
        NgSelect2Module,
        WidgetsModule,
        MatTabsModule,
        MatDatepickerModule,
        MatInputModule,
        MatSelectModule,
        MatDividerModule,
        MatCheckboxModule,
        NgbCollapseModule,
        MatProgressSpinnerModule,
        MatIconModule,
        NgbAlertModule,
        NgbPaginationModule,
        SharedModuleModule,
    ]
})
export class CustomerSupportModule { }
